import { createVNode as e, mergeProps as n } from "vue";
import f from "../node_modules/@pf-ui/pf-icon-svg/es/asn/StaffMaleTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (a, o) => {
  const r = {
    ...a,
    ...o.attrs
  };
  return e(d, n(r, {
    icon: f
  }), null);
};
t.displayName = "StaffMaleTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
